import { ComponentPropsWithoutRef } from 'react';

export const RadioControl = (props: ComponentPropsWithoutRef<'input'>) => {
    return <input {...props} type="radio" />;
};
